import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
  install(app) {
    app.config.globalProperties.$bodyscroll = {
      /**
       * Disables body scroll via body-scroll-lock plugin.
       *
       * @param {Object} element - The target element.
       */
      disableBodyScroll(element) {
        const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

        document.body.style.setProperty('--hidden-scrollbar-width', `${scrollBarWidth}px`);

        disableBodyScroll(element, {
          reserveScrollBarGap: true,
        });
      },

      /**
       * Enables body scroll via body-scroll-lock plugin.
       *
       * @param {Object} element - The target element.
       */
      enableBodyScroll(element) {
        document.body.style.setProperty('--hidden-scrollbar-width', '0px');

        enableBodyScroll(element);
      },
    };
  },
};
